module.exports = __webpack_public_path__ + "static/media/hoops_logo.dc7874f3.svg";